// React-Query hooks для Sprint 6-organs (Трек B, Stage 4[B]).
// GET /api/v1/dashboard/organs + /organs/{organ}. Source of truth:
// docs/specs/sprint-6-organs/stage-1-contracts.md §3/§6.2.
//
// Ключи под ['dashboard'] umbrella (queryKeys.organs/organ) — данные органов
// выводятся из тех же точек, что и /dashboard (единый расчёт backend §3).

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '@/api/client';
import { queryKeys } from '@/api/queryKeys';
import type { OrganDetail, OrgansListResponse } from '@/api/types';

export function useOrgans(): UseQueryResult<OrgansListResponse> {
  return useQuery({
    queryKey: queryKeys.organs,
    queryFn: async () => {
      // RF-S5-S4-1: baseURL уже = `${VITE_API_URL}/api/v1` — relative path.
      const { data } = await api.get<OrgansListResponse>('/dashboard/organs');
      return data;
    },
  });
}

export function useOrgan(code: string): UseQueryResult<OrganDetail> {
  return useQuery({
    queryKey: queryKeys.organ(code),
    queryFn: async () => {
      const { data } = await api.get<OrganDetail>(
        `/dashboard/organs/${encodeURIComponent(code)}`,
      );
      return data;
    },
    enabled: !!code,
  });
}
